import React from 'react';
import AppleDownload from '../assets/img/mockupsiconsandbadges/AppStoreBadge.png';
import GoogleDownload from '../assets/img/mockupsiconsandbadges/GooglePlayBadge.png';

export default function DownloadPlatforms() {
  return (
    <div className="download-platforms">
      <a href="https://apps.apple.com/ng/app/raven-livestream/id1541951758">
        <img src={AppleDownload} alt="" className="button" />
      </a>
      <a href="" className="button">
        <img
          src={GoogleDownload}
          alt="https://play.google.com/store/apps/details?id=com.ravenlivestream.raven"
        />
      </a>
    </div>
  );
}
